<script lang="ts">
  import { userbaseStore } from "../../stores/stores";
  import Card from "../../shared/Card.svelte";
  import Modal from "../../shared/Modal.svelte";
  import Input from "../../shared/Input.svelte";
  import Button from "../../shared/Button.svelte";
  import { ArticleType, DatabaseName, ActionType } from "../../stores/types";
  import type { Article } from "../../stores/types";
  import Accordion from "../../shared/Accordion.svelte";

  export let articleItem: Article, itemId: string;

  const artcleTypes = Object.entries(ArticleType);
  let actionType: ActionType = null;
  let databaseNameArticle = DatabaseName.ARTICLES.toString();
  let entryPromise = null;
  let logPromise = null;
  let sauerteig: boolean = false;
  let newArticle = { name: articleItem.name, type: articleItem.type };

  if (articleItem.type === ArticleType.SAUERTEIG.toString()) {
    sauerteig = true;
  }

  // edit article in a modal dialog
  let showModal = false;
  const toggleModal = () => {
    showModal = !showModal;
  };

  // edit item
  const handleEdit = () => {
    // edit article in DB
    let entry: Article = { ...newArticle };
    entryPromise = $userbaseStore.updateItem({
      databaseName: databaseNameArticle,
      item: entry,
      itemId: itemId,
    });

    toggleModal();
  };

  // delete item
  const handleDelete = () => {
    if (confirm("really delete this item?:   " + articleItem.name)) {
      actionType = ActionType.DELETE;
      logAction();
      entryPromise = $userbaseStore.deleteItem({
        databaseName: databaseNameArticle,
        itemId,
      });
    }
  };

  const logAction = () => {
    var logItem = {
      dbname: "articles",
      action: actionType.toString(),
      changedItem: articleItem,
    };
    logPromise = $userbaseStore.insertItem({
      databaseName: "logs",
      item: logItem,
    });
  };
</script>

<Modal {showModal} on:click={toggleModal}>
  <form on:submit|preventDefault={handleEdit}>
    <h2>Edit Artikel</h2>
    <Input label="Name:" bind:value={newArticle.name} type="text" required />
    <select bind:value={newArticle.type}>
      {#each artcleTypes as entry}
        <option value={entry[1]}>{entry[1]}</option>
      {/each}
    </select>

    <Button type="secondary" flat={true}>Artikel aktualisieren</Button>
  </form>
</Modal>
<Card>
  <div class="ingredient" title={itemId}>
    <div class="header">
      <h3>{articleItem.name}</h3>

      <div class="delete-item" title="Edit item">
        <span class="tag" class:sauerteig>{articleItem.type}</span>
        <span class="icon-button"><i class="fas fa-pen" on:click={() => toggleModal()} /></span>
        <span class="icon-button"><i class="fas fa-trash-alt" on:click={() => handleDelete()} /></span>
      </div>
    </div>
  </div>
</Card>

<style>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  h3 {
    margin: 5px;
    color: rgb(109, 55, 33);
  }
  .icon-button {
    font-size: medium;
    color: dimgrey;
    margin-right: 10px;
    cursor: pointer;
  }
  .tag {
    border-radius: 6px;
    padding: 5px;
    margin-right: 10px;
    font-size: small;
    background-color: lightsalmon;
  }
  .sauerteig {
    background-color: lightgrey;
  }
</style>
